import { TextBadge } from 'components/Badge/TextBadge';
import { SearchFacetAccordionItem } from 'modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from 'modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from 'modules/search/components/Facet/Options/SearchFacetCheckboxOptions';
import { useSearchFacetSelectedValues } from 'modules/search/hooks/facets/useSearchFacetSelectedValues';
import { SearchFacetVariant } from 'modules/search/types/SearchFacetVariant';
import { PROFESSIONAL_LEVEL_CHECKBOX_OPTIONS } from 'utils/constants/general/professionalLevels';

type Props = {
  variant?: SearchFacetVariant;
};
export function ProfessionalLevelFacet({ variant = 'dropdown' }: Props) {
  const selectedFacetValues =
    // @ts-expect-error Fix Type
    useSearchFacetSelectedValues('professionalLevel');

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="professionalLevel"
      icon="stairs"
      label={
        <>
          {getText('Experience Level')}{' '}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType="professionalLevel"
        initialValue={selectedFacetValues}
        options={PROFESSIONAL_LEVEL_CHECKBOX_OPTIONS()}
      />
    </FacetVariant>
  );
}
